<button class="bf-burger" [ngClass]="color" (click)="clicked.emit()">
  <div class="bf-burger-line"></div>
  <div class="bf-burger-line"></div>
  <div class="bf-burger-line"></div>
</button>
